import React from 'react';
import {inject, observer} from 'mobx-react';
import {IMG_PATH} from '../../constant';
import './index.scss';
import {commonJump} from 'utils/utils';

@inject(({store}) => ({
    rmtj: store.renderData.rmtj
}))
@observer
class HotRec extends React.Component {
    render() {
        const {rmtj: {data = []}} = this.props;
        if (!data.length) {
            return null;
        }
        return <div className="module m-nav m-hotRec" id="mstj">
            <img className="img-bg" src={`${IMG_PATH}/hotRec.png`} />
            <div className="mh-content">
                {
                    data.slice(0, 2).map((v, k) => {
                        const {img = {}, jumpInfo = {}} = v;
                        return <div className="item_1" data-sk-eid="list_tuijian" data-sk-edata={JSON.stringify({url: jumpInfo})} onClick={() => {
                            if(!jumpInfo.touchUrl) return;
                            commonJump(jumpInfo);
                        }}><img className="img_1" key={k} src={img.touch} /></div>;
                    })
                }
                {
                    data.slice(2, 5).map((v, k) => {
                        const {img = {}, jumpInfo = {}} = v;
                        return <div className="item_2" data-sk-eid="list_tuijian" data-sk-edata={JSON.stringify({url: jumpInfo})} onClick={() => {
                            if(!jumpInfo.touchUrl) return;
                            commonJump(jumpInfo);
                        }}><img className="img_2" key={k} src={img.touch} /></div>;
                    })
                }
            </div>
        </div>;
    }
}

export default HotRec;